module.exports = __webpack_public_path__ + "static/ferrous-shadow-652c42d9f083051150237afa52f3c3ef.png";